import { queryFeatures } from '@esri/arcgis-rest-feature-layer';
import Polygon from '@arcgis/core/geometry/Polygon';
import Graphic from '@arcgis/core/Graphic';
import Titles from './Titles';

const GARBAGE_SERVICE =
  // 'https://maps.victoriatx.org/arcgis/rest/services/SOLID_WASTE/MapServer/0';
  'https://maps.victoriatx.gov/arcgis/rest/services/PublishedServices/SolidWaste/MapServer/0';
const YARD_SERVICE =
  // 'https://maps.victoriatx.org/arcgis/rest/services/SOLID_WASTE/MapServer/1';
  'https://maps.victoriatx.gov/arcgis/rest/services/PublishedServices/SolidWaste/MapServer/1';
const RECYCLING_SERVICE =
  // 'https://maps.victoriatx.org/arcgis/rest/services/SOLID_WASTE/MapServer/2';
  'https://maps.victoriatx.gov/arcgis/rest/services/PublishedServices/SolidWaste/MapServer/2';
const BRUSH_SERVICE =
  // 'https://maps.victoriatx.org/arcgis/rest/services/SOLID_WASTE/MapServer/3';
  'https://maps.victoriatx.gov/arcgis/rest/services/PublishedServices/SolidWaste/MapServer/3';
const COUNCIL_DISTRICT_SERVICE =
  // 'https://maps.victoriatx.org/arcgis/rest/services/Political_Boundaries/MapServer/1';
  'https://maps.victoriatx.gov/arcgis/rest/services/PublishedServices/Political_Boundaries/MapServer/1';
const SUPER_DISTRICT_SERVICE =
  // 'https://maps.victoriatx.org/arcgis/rest/services/Political_Boundaries/MapServer/2';
  'https://maps.victoriatx.gov/arcgis/rest/services/PublishedServices/Political_Boundaries/MapServer/2';
const FIRE_DISTRICT_SERVICE =
  // 'https://maps.victoriatx.org/arcgis/rest/services/Public_Safety/MapServer/3';
  'https://maps.victoriatx.gov/arcgis/rest/services/PublishedServices/Public_Safety/MapServer/3';

function buildGraphic(feature, title) {
  const polygon = new Polygon({
    type: 'polygon',
    rings: feature.geometry.rings,
  });
  const fillSymbol = {
    type: 'simple-fill',
    // color,
    outline: {
      color: [255, 255, 255],
      width: 1,
    },
  };

  const fieldInfos = [];
  switch (title) {
    case Titles.GARBAGE:
    case Titles.YARD:
    case Titles.RECYCLING:
      fieldInfos.push({
        fieldName: 'PickUpDay',
        label: 'Day',
      });
      break;
    case Titles.BRUSH:
      fieldInfos.push({
        fieldName: 'ROUTE',
        label: 'Route',
      });
      break;
    case Titles.COUNCIL:
    case Titles.SUPER:
      fieldInfos.push({
        fieldName: 'District',
        label: 'District',
      });
      break;
    case Titles.FIRE:
      fieldInfos.push({
        fieldName: 'DIST_ID',
        label: 'District',
      });
      break;
    default:
  }
  const graphic = new Graphic({
    geometry: polygon,
    symbol: fillSymbol,
    attributes: feature.attributes,
    popupTemplate: {
      title,
      content: [
        {
          type: 'fields',
          fieldInfos,
        },
      ],
    },
  });

  return graphic;
}

function getAreaGraphic(url, title, x, y) {
  return new Promise((resolve, reject) => {
    queryFeatures({
      url,
      geometry: `${x},${y}`,
      geometryType: 'esriGeometryPoint',
      inSR: 4326,
      outSR: 4326,
      spatialRel: 'esriSpatialRelWithin',
      outFields: '*',
      returnGeometry: true,
      f: 'json',
    }).then((response) => {
      console.log('getAreaGraphic response:');
      console.log(response);
      if (response.features && response.features.length > 0) {
        const graphic = buildGraphic(response.features[0], title);
        resolve(graphic);
      } else {
        resolve(null);
      }
    });
  });
}

export function getGarbageDays(x, y) {
  return new Promise(async (resolve, reject) => {
    const url = GARBAGE_SERVICE;
    const graphic = await getAreaGraphic(url, Titles.GARBAGE, x, y);
    console.log('garbage graphic:');
    console.log(graphic);
    // const day = graphic.features?.[0].attributes.PickUpDay;
    // console.log(`garbage day: ${day}`);
    // resolve(day);
    resolve(graphic);
  });
}

export function getYardDays(x, y) {
  return new Promise(async (resolve, reject) => {
    const url = YARD_SERVICE;
    const graphic = await getAreaGraphic(url, Titles.YARD, x, y);
    console.log('yard graphic:');
    console.log(graphic);
    // const day = graphic.features?.[0].attributes.PickUpDay;
    // console.log(`yard day: ${day}`);
    // resolve(day);
    resolve(graphic);
  });
}

export function getRecyclingDays(x, y) {
  return new Promise(async (resolve, reject) => {
    const url = RECYCLING_SERVICE;
    const graphic = await getAreaGraphic(url, Titles.RECYCLING, x, y);
    console.log('recycling graphic:');
    console.log(graphic);
    // const day = graphic.features?.[0].attributes.PickUpDay;
    // console.log(`recycling day: ${day}`);
    // resolve(day);
    resolve(graphic);
  });
}

export function getBrushDays(x, y) {
  return new Promise(async (resolve, reject) => {
    const url = BRUSH_SERVICE;
    const graphic = await getAreaGraphic(url, Titles.BRUSH, x, y);
    console.log('brush graphic:');
    console.log(graphic);
    // const day = graphic.features?.[0].attributes.ROUTE;
    // console.log(`brush day: ${day}`);
    // resolve(day);
    resolve(graphic);
  });
}

export function getCouncilDistrict(x, y) {
  return new Promise(async (resolve, reject) => {
    const url = COUNCIL_DISTRICT_SERVICE;
    const graphic = await getAreaGraphic(url, Titles.COUNCIL, x, y);
    console.log('council district graphic:');
    console.log(graphic);
    // const day = graphic.features?.[0].attributes.District;
    // console.log(`council district: ${day}`);
    // resolve(day);
    resolve(graphic);
  });
}

export function getSuperDistrict(x, y) {
  return new Promise(async (resolve, reject) => {
    const url = SUPER_DISTRICT_SERVICE;
    const graphic = await getAreaGraphic(url, Titles.SUPER, x, y);
    console.log('super district graphic:');
    console.log(graphic);
    // const day = graphic.features?.[0].attributes.District;
    // console.log(`super district: ${day}`);
    // resolve(day);
    resolve(graphic);
  });
}

export function getFireDistrict(x, y) {
  return new Promise(async (resolve, reject) => {
    const url = FIRE_DISTRICT_SERVICE;
    const graphic = await getAreaGraphic(url, Titles.FIRE, x, y);
    console.log('fire district graphic:');
    console.log(graphic);
    // const day = graphic.features?.[0].attributes.DIST_ID;
    // console.log(`fire district: ${day}`);
    // resolve(day);
    resolve(graphic);
  });
}
